const COPILOT_SSE_STREAM_FLAG = 'copilot_sse_stream';

export const shouldUseCopilotSseStream = (
  environmentName: string | undefined,
  copilotSseStreamFlagEnabled: boolean
) => environmentName !== 'staging' && copilotSseStreamFlagEnabled;

export const shouldUseCopilotSseStreamForFlags = (
  environmentName: string | undefined,
  userFlags: string[] | undefined
) =>
  shouldUseCopilotSseStream(
    environmentName,
    Boolean(userFlags?.includes(COPILOT_SSE_STREAM_FLAG))
  );
